module.exports = __webpack_public_path__ + "static/img/F03-合肥上海世界外国语学校1.12f1517.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/F03-合肥上海世界外国语学校1.png
// module id = Gi5j
// module chunks = 0